import { render, staticRenderFns } from "./TargetTherapyBlock.vue?vue&type=template&id=b3a9d80e&lang=pug&"
import script from "./TargetTherapyBlock.vue?vue&type=script&lang=js&"
export * from "./TargetTherapyBlock.vue?vue&type=script&lang=js&"
import style0 from "./TargetTherapyBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports